<template>
  <router-btn :text="$t('servicesystem.common_objects.document.print')" :icon="'mdi-printer'" :color="'primary'"
    :outlined="true" :loading="loading" :disabled="false" :textbtn="textbtn" :large="large" :small="small"
    @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import ClientAPIMixin from "@/api/ClientAPIMixin";
import BlobFileMixin from "@/helpers/Mixins/BlobFileMixin";

export default {
  name: "PrintServiceReportBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [ClientAPIMixin],

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async action() {
      this.loading = true;
      console.log("Printing service report");
      var file = await this.downloadReport(this.jobId);
      await BlobFileMixin.methods.printBlobData(file.blob);
      this.loading = false;
    },
  },

  computed: {
    jobId() {
      return parseInt(this.$route.params.jobId) || null;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
